import { Icon } from '@oneaudi/unified-web-components';
import React, { useContext, type FC } from 'react';
import styled from 'styled-components';
import { UniversalStateContext } from '../context/UniversalStateContext';

type Direction = 'back' | 'forward';

const StyledNavigationButton = styled.button<{ visible: boolean; direction: Direction }>`
  appearance: none;
  background-color: ${({ theme }) => theme.colors.sysColorSurfaceNeutral800};
  opacity: ${({ visible }) => (visible ? 1 : 0.75)};
  border: none;
  padding: 12px;
  color: inherit;
  border-radius: ${(props) => (process.env.IS_LEGACY ? 0 : props.theme.borderRadius.max)};
  margin: 0 ${(props) => (process.env.IS_LEGACY ? 0 : props.theme.spacing.pageMargin)};

  @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 16px;
  }

  transform: ${({ direction }) => direction === 'back' && 'rotate(-180deg)'};
  pointer-events: auto;

  &:not(:disabled):hover {
    cursor: pointer;
  }

  & > svg {
    color: ${({ theme, disabled }) =>
      disabled
        ? theme.colors.sysColorSurfaceNeutral400
        : theme.colors.semColorActionPrimaryForegroundIconDefault};
    display: block;
    fill: currentColor;
  }
`;

export interface NavigationButtonProps {
  readonly onClick: () => void;
  readonly direction: Direction;
  readonly disabled?: boolean;
}

export const NavigationButton: FC<NavigationButtonProps> = ({
  onClick,
  direction,
  disabled = false,
}) => {
  const { i18nTexts } = useContext(UniversalStateContext)!;
  return (
    <StyledNavigationButton
      onClick={onClick}
      visible={!disabled}
      disabled={disabled}
      direction={direction}
      aria-label={direction === 'back' ? i18nTexts.previousButtonText : i18nTexts.nextButtonText}
    >
      <Icon name="forward" size="s" />
    </StyledNavigationButton>
  );
};
